import { getAuth } from "firebase/auth";

export default async function handleSubscription(plan) {
  try {
    // This calls the Express "api" we just set up
    const API_BASE_URL =
      "https://us-central1-reflectrise-c0ad4.cloudfunctions.net/api";

    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      alert("Please sign in first.");
      return;
    }

    const uid = user.uid;
    const email = user.email;

    console.log(
      `🟣 Creating checkout session for ${email} (${uid}) plan: ${plan}`
    );

    const response = await fetch(`${API_BASE_URL}/create-checkout-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        plan,
        email,
        uid, // send uid to server
      }),
    });

    const data = await response.json();

    if (response.ok && data.url) {
      window.location.href = data.url;
    } else {
      console.error("❌ Failed to create checkout session:", data);
      alert("Something went wrong. Try again.");
    }
  } catch (error) {
    console.error("❌ Stripe Checkout Error:", error);
    alert("Something went wrong. Please try again.");
  }
}
